<template>
  <v-col>
    <v-row :justify="admin ? 'space-between' : 'end'" class="mx-0 mb-1">
      <delete-button
        v-if="admin"
        quiet
        headline="Delete Image?"
        :disabled="imageInQuote"
        disabledText="Image used in a quote. Cannot delete."
        :ondelete="deleteImage"
      />
    </v-row>
    <v-row>
      <v-col>
        <ImageInfo />
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import ImageInfo from "@/modules/images/components/ImageInfo";

export default {
  components: {
    ImageInfo,
  },
  data() {
    return {
      imageInQuote: false,
    };
  },
  computed: {
    admin() {
      return this.$store.getters["isAdmin"];
    },
  },
  methods: {
    deleteImage() {
      return this.$store
        .dispatch("ImageStore/deleteImage")
        .then((v) => {
          this.$root.$success("Deleted Image");
          this.$router.push({
            name: "database_view",
            params: {
              view: "images",
              sub: "ALL",
            },
          });
        })
        .catch((err) => this.$root.$error(err));
    },
    saveImage() {
      return this.$store
        .dispatch("ImageStore/updateImage")
        .then((v) => this.$root.$success("Updated Image"))
        .catch((err) => this.$root.$error(err));
    },
  },
  mounted() {
    const imageId = this.$store.getters["ImageStore/id"] || this.$route.params.id;
    this.$store
      .dispatch("ImageStore/checkImageInQuote", imageId)
      .then((val) => {
        this.imageInQuote = !!val.count;
      })
      .catch((err) => this.$root.$error(err));
  },
  beforeDestroy() {
    if (this.$store.getters["ImageStore/hasChanges"]) {
      this.saveImage();
    }
  },
};
</script>
